<template>
  <div class="player">
    <div
      style="width: 100%; display: flex; align-items: center; justify-content: center; border-radius: 20px; overflow: hidden; height: 40px !important; border-top-left-radius: 5px; border-bottom-left-radius: 5px"
    >
      <audio src="https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_700KB.mp3"></audio>
      <div class="player-bar">
        <span
          v-if="sound != null && sound._duration != null"
          style="font-size: 12px; color: #fff; position: absolute; left: 5px; font-weight: bold"
        >{{ Math.floor(sound._duration - current).toFixed(0) }}s</span>
        <div
          v-if="sound != null"
          class="bar"
          :style="'width: ' + Math.round((100 / sound._duration) * current) + '%;'"
        ></div>
      </div>
      <button
        :disabled="locked || count == 0"
        @click="play"
        :class="mustlisten ? 'play-button-animated' : 'play-button'"
      >
        <i
          class="el-icon-caret-right"
          style="font-size: 35px;     position: relative; z-index: 999"
        />
      </button>
    </div>
    <div style="display: flex; flex-direction: row; justify-content: center; width: 100%;">
      <span style="font-size: 12px; color: gray">
        chances to listen left:
        <strong>{{ count }}</strong>
      </span>
    </div>
  </div>
</template>

<script>
import { Howl, Howler } from "howler";
export default {
  name: "audioPlayer",
  props: ["url", "mustlisten"],
  data() {
    return {
      count: 2,
      sound: null,
      current: 0,
      interval: null,
      locked: false
    };
  },
  mounted() {
    if (this.url == null) {
      this.url = "../static/sound.mp3";
    }

    this.sound = new Howl({
      src: [this.url],
      preload: true,
      format: ["mp3"]
    });
  },
  methods: {
    play() {
      this.$emit("played");

      if (this.count != 0) {
        this.sound.play();
        this.locked = true;
        this.startInterval();
        this.count -= 1;
      }

      setTimeout(() => {
        this.sound.on("end", () => {
          clearInterval(this.interval);
          this.locked = false;
        });
      }, 200);
    },
    startInterval() {
      this.interval = setInterval(() => {
        this.current = this.sound.seek();
      }, 100);
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
    this.interval = null;
    this.sound.stop();
    this.sound = null;
  }
};
</script>

<style lang="less">
.player {
  width: 300px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  position: relative;
}

.player-bar {
  background-color: #191659;
  display: flex;
  flex: 1;
  height: 40px;
}

.bar {
  transition: linear 1s;
  background-color: #a62a4c;
}

.play-button-animated {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  position: absolute;
  right: 5px;
  font-size: 20px;
  padding: 0px;
  outline: none;
  border: none;
  background: transparent;

  &:before {
    content: "";
    position: absolute;
    display: block;
    width: 300%;
    height: 300%;
    box-sizing: border-box;
    margin-left: -100%;
    margin-top: -100%;
    border-radius: 50%;
    animation: pulse-ring 1.25s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
    background: #a62a4c;
  }

  &:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
    animation: pulse-dot 1.25s cubic-bezier(0.455, 0.03, 0.515, 0.955) -0.4s infinite;
    background: #fff;
  }
}

.play-button {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  position: absolute;
  right: 5px;
  font-size: 20px;
  padding: 0px;
  outline: none;
  border: none;
  background: transparent;
  background: #fff;
}

@keyframes pulse-ring {
  0% {
    transform: scale(0.33);
  }
  80%,
  100% {
    opacity: 0;
  }
}

@keyframes pulse-dot {
  0% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.8);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Player.vue